import { render, staticRenderFns } from "./TopIP.vue?vue&type=template&id=6074d59a&scoped=true"
import script from "./TopIP.vue?vue&type=script&lang=js"
export * from "./TopIP.vue?vue&type=script&lang=js"
import style0 from "./TopIP.vue?vue&type=style&index=0&id=6074d59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6074d59a",
  null
  
)

export default component.exports